import React from "react";
import { setEditId, PostInterface } from "src/store/community/postsSlice";
import IconText from "src/componets/IconText";
import { HeartOutlined, LikeOutlined, MessageOutlined } from "@ant-design/icons";
import { ButtonDestroy, ButtonEdit, ButtonToggleShow } from "src/componets/Buttons";
import Meta from "../../Users/_partials/_Meta";
import CardImage from "src/componets/CardImage";
import { EntityId } from "@reduxjs/toolkit";
import { destroyPost, toggleShow } from "src/actions/community/postsActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store/hooks";
import { UserInterface } from "src/store/community/usersSlice";
import { formattedDate } from "src/helpers/DateHelpers";
import { HiddenTag } from "src/componets//Tags/HiddenTag";

interface propsInterface {
  post: PostInterface;
  user?: UserInterface | undefined;
}

const Card = ({ post, user }: propsInterface) => {
  const navigate            = useNavigate();
  const dispatch            = useAppDispatch();
  const formattedCreatedAt  = formattedDate(post.created_at);

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  function onToggleShow(id: any) {
    dispatch(toggleShow({ id, published: post.published }));
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyPost(id));

    if (destroyPost.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyPost.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <CardImage
      className={'v-community-posts__card'}
      image={post.thumbnail_url}
      title={post.title}
      link={post.url}
      size='medium'
      stats={[
        <IconText tooltip='popular' icon={HeartOutlined} text={post.popular_count} />,
        <IconText tooltip='likes' icon={LikeOutlined} text={post.likes_count} />,
        <IconText tooltip='comments' icon={MessageOutlined} text={post.comments_count} />
      ]}
      options={[
        <ButtonToggleShow
          key={`show-${post.id}`}
          onClick={() => onToggleShow(post.id)}
          state={post.published}
        />,
        <ButtonEdit key={`edit-${post.id}`} onClick={() => onClickEdit(post.id)} />,
        <ButtonDestroy key={`destroy-${post.id}`} onClick={() => onClickDestroy(post.id)} />
      ]}
      labels={[<HiddenTag key={`show-tag-${post.id}`} hidden={!post.published} />]}
    >
      {user && <Meta user={user} size='xsmall' />}

      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
